import {
  tag_colorTagDefaultText,
  tag_colorTagPendingText,
  tag_colorTagSevereText,
} from 'ext-ui/style/colors'
import ReceiptIcon from 'ext-ui/svg/icon/ReceiptIcon'
import ReceiptMissingIcon from 'ext-ui/svg/icon/ReceiptMissingIcon'
import React, { ReactElement } from 'react'
import { ReceiptState } from 'src/feature/ReceiptRecovery/receiptRecovery.types'

interface ReceiptStateIconProps {
  state: ReceiptState
}

const ReceiptStateIcon = ({ state }: ReceiptStateIconProps): ReactElement => {
  const commonProps = {
    'aria-hidden': true,
    focusable: false,
    role: 'presentation',
  } as const

  if (state === 'missing-receipt') {
    return <ReceiptMissingIcon {...commonProps} fill={tag_colorTagSevereText} />
  }

  const fill =
    state === 'needs-review'
      ? tag_colorTagPendingText
      : tag_colorTagDefaultText

  return <ReceiptIcon {...commonProps} fill={fill} />
}

export default ReceiptStateIcon
